import { render, staticRenderFns } from "./OrderDetailsDrawer.vue?vue&type=template&id=299713c5&scoped=true"
import script from "./OrderDetailsDrawer.vue?vue&type=script&lang=js"
export * from "./OrderDetailsDrawer.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailsDrawer.vue?vue&type=style&index=0&id=299713c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "299713c5",
  null
  
)

export default component.exports